import React, { PureComponent } from 'react'
import { Row, Col } from 'pui-react-grids'
import { themeColors } from '../styles/theme'

const styles = {
  image: {
    maxWidth: 300,
    height: 'auto',
  },
  titles: {
    color: themeColors.positive,
    fontSize: 26,
  },
}

class ScaricaApp extends PureComponent {
  render() {
    return (
      <div>
        <Row>
          <Col md={8} style={{ textAlign: 'right' }}>
            <div style={{ marginTop: 80 }}>
              <h3 style={styles.titles}>Scarica l'app</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices.
              </p>
            </div>
            <div>
              <h3 style={styles.titles}>Scarica l'app</h3>
            </div>
          </Col>
          <Col md={8} style={{ textAlign: 'center' }}>
            <img alt="App Phone" src="/img/appphone.png" style={styles.image} />
          </Col>
          <Col md={8} />
        </Row>
      </div>
    )
  }
}

export default ScaricaApp



// WEBPACK FOOTER //
// ./src/pages/ScaricaApp.js